/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=7c386345&scoped=true&"
import script from "./Index.vue?vue&type=script&setup=true&lang=js&"
export * from "./Index.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=7c386345&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c386345",
  null
  
)

export default component.exports